module.exports = __webpack_public_path__ + "img/doggy-package.170cc8bb.png";